import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbandonDossierFitterSheetComponent } from '@sc/ui-components';
import { DossierAbandonOutputData } from '@sc/data-access-models';

@Component({
  selector: 'sc-dossier-abandon-fitter-dialog',
  styleUrls: ['./dossier-abandon-fitter-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [AbandonDossierFitterSheetComponent],
  template: `
    <sc-abandon-dossier-fitter-sheet
      (abandonCommentResult)="onAbandonCommentResult($event)"
    ></sc-abandon-dossier-fitter-sheet>
  `,
})
export class DossierAbandonFitterDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<
      DossierAbandonFitterDialogComponent,
      DossierAbandonOutputData
    >
  ) {}

  onAbandonCommentResult($event) {
    this.dialogRef.close($event);
  }

  @HostListener('window:resize', ['$event'])
  closeOnResize() {
    this.onAbandonCommentResult({ type: 'cancel' });
  }
}
